import React from 'react';

interface BellIconProps {
    size?: number;
    color?: string;
}

const BellIcon: React.FC<BellIconProps> = ({ size = 18, color = '#0F172A' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 3.5a6 6 0 00-6 6v3.382a2 2 0 01-.211.894L4 17h16l-1.789-3.224A2 2 0 0118 12.882V9.5a6 6 0 00-6-6z"
            stroke={color}
            strokeWidth="1.6"
            strokeLinejoin="round"
        />
        <path d="M10 20a2 2 0 004 0" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

export default BellIcon;
